

















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { IDocType } from "@/@types/admin/guest/user";
import identity_cards from "@/config/identity/identity_cards";
import {
  requiredIf,
  numeric,
  maxLength,
  minLength,
} from "vuelidate/lib/validators";
import { isValidPassport } from "@/services/user/personal_data";

@Component({
  mixins: [validationMixin],
  validations: {
    doc: {
      required: requiredIf(function (this: any) {
        return this.required;
      }),
      numeric,
      maxLength: maxLength(10),
      minLength: minLength(10),
    },
  },
})
export default class Document0 extends Vue {
  @Prop({ type: String, default: "" }) document!: string;
  @Prop({ type: String, default: "" }) type!: string;
  @Prop({ type: Boolean, default: true }) required!: boolean;

  doc = "";
  number = true;
  foo = 10;

  get doctype(): IDocType | null {
    const type = identity_cards.find((el) => el._id == this.type);
    return type ? type : null;
  }

  get isValid(): boolean {
    return isValidPassport(this.doc);
  }

  @Watch("doc")
  processingDoc(): void {
    this.doc = this.doc.replace(/\s+/g, "");
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }
    if (!this.isValid) return;
    this.$emit("number", this.doc);
  }

  @Watch("document")
  createDoc(): void {
    if (!this.document) return;
    this.doc = this.document;
  }

  mounted(): void {
    this.createDoc();
  }
}
